import { useState, useEffect } from 'react';
import { CompareHero } from './CompareHero';
import { CompareTable } from './CompareTable';
import { AdSlot } from '@/components/common/AdSlot';

export const CompareView = ({ items }) => {
  const [selectedId, setSelectedId] = useState(items[0]?.id);

  useEffect(() => {
    setSelectedId(items[0]?.id);
  }, [items]);

  const selected = items.find((i) => i.id === selectedId) || items[0];

  return (
    <div className="space-y-4">
      <CompareHero listing={selected} />
      <AdSlot slotId="grid-native" size="native" />
      <CompareTable items={items} selectedId={selectedId} onSelect={setSelectedId} />
    </div>
  );
};
